import React, { useEffect, useState } from "react";
import styled from "styled-components";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { Box, Grid, Typography, Button, TextField } from "@material-ui/core";
import { toast } from "react-toastify";
import { modal, formatDatetime } from "../../../../util";
import { Link } from "react-router-dom";
import DragAndDropTable from "../../../common/DragAndDropTable";
import {
  useAsyncDebounce,
} from "react-table";

const FilterDiv = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 20px;

  p {
    font-size: 13px;
    line-height: 15px;
    color: #306f9d;
    padding-left: 3px;
    padding-right: 3px;
    cursor: pointer;

    span {
      color: #333333;
    }

    &.active {
      font-weight: bold;
      color: #333333;
    }

    &:first-child {
      padding-left: 0;
    }
  }
`;

export default function JobPage(props) {
  const { disabled, match } = props;
  const [globalFilter, setGlobalFilter] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchString, setSearchString] = useState("");
  const { setLoading } = useLoading();
  const [pageSize, setPageSize] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  
  const [filterEnabled, setFilterEnabled] = React.useState([]);
  const [filterDisabled, setFilterDisabled] = React.useState([]);
  const [filterStatus, setFilterStatus] = React.useState("all");
  const [allData, setAllData] = React.useState([]);
  //for storing total count
  const [totalCount, setTotalCount] = React.useState(0);

  // useEffect(() => {
  //   getJobs();
  // }, [pageIndex, pageSize, searchString, setLoading]);

  // const getJobs = () => {
  //   apiHelper.hkiff.getJobs().then((response) => {
  //     console.log(response);
  //     setRows(response.data.content);
  //     setAllData(response.data.content);
  //     setFilterEnabled(
  //       response.data.content.filter((x) => x.status === "Enable")
  //     );
  //     setFilterDisabled(response.data.content.filter((x) => x.status === "Disable"));
  //   });
  // };

  const getJobs = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getJobs(
        null,
        pageIndex,
        (pageIndex + 1) * pageSize,
        pageSize,
        searchString
      );
      setRows(result.data.content.filter((x) => x));
      setAllData(result.data.content);
      setTotalPages(result.data.totalPages);

      const allResult = await apiHelper.hkiff.getJobs(
        null,
        null,
        null,
        null,
        null,
        true
      ).then((response) => {
        setTotalElements(response.data.totalElements);
        setFilterEnabled  (
          response.data.content.filter((x) => x.status === "Enable")
        );
        setFilterDisabled(
          response.data.content.filter((x) => x.status === "Disable")
        );
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [pageIndex, pageSize, searchString, setLoading]);

  React.useEffect(() => {
    if (pageSize) getJobs();
  }, [getJobs]);

  const handleSorting = (bool) => {
    if (!isSearched) {
      setOrderingDisabled(bool);
    }
  };

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setIsSearched(true);
    setOrderingDisabled(true);
  };

  const handleDelete = async (id) => {
    const decision = await modal.fire({
      title: "Delete position",
      text: "Are you sure to delete this position?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        await apiHelper.hkiff.deleteJobById(id);
        toast.dark("The position is deleted.");
        await getJobs();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const filterDataWithStatus = (status) => {
    setIsSearched(true);
    setOrderingDisabled(true);
    setFilterStatus(status);

    switch (status) {
      case "Enable":
        setRows(filterEnabled);
        setTotalElements(filterEnabled.length);
        break;

      case "Disable":
        setRows(filterDisabled);
        setTotalElements(filterDisabled.length);
        break;

      case "all":
      default:
        setRows(allData);
        setTotalElements(filterEnabled.length+filterDisabled.length);
        setIsSearched(false);
        setOrderingDisabled(false);
        break;
    }
  };

  const getMaxSeqInRows = (rows) => {
    let seq = null;
    rows.forEach((e) => {
      if ((e.seq && seq === null) || (seq !== null && e.seq > seq)) {
        seq = e.seq
      }
    })
    return seq;
  }

  const saveOrdering = async () => {
    try {
      const maxSeq = getMaxSeqInRows(rows);
      const seqData = {};
      var size = rows.length;
      rows.forEach((e, i) => {
        seqData[e.id] = maxSeq-size+i+1;
      });
      const result = await apiHelper.hkiff.orderJobs(seqData);
      if (result.data.code === 0) {
        toast.dark("Your changes is saved.");
        await getJobs();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Job Title (English)",
        accessor: "jobTitleEn",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.jobTitleEn}
            </Link>
          );
        },
      },
      {
        Header: "Job Title (Traditional Chinese)",
        accessor: "jobTitleTc",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.jobTitleTc}
            </Link>
          );
        },
      },
      {
        Header: "Type",
        accessor: "type",
        Cell: ({ row }) => {
          return (
            row.original.type
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row }) => {
          return (
            row.original.status
          );
        },
      },
      {
        Header: "Last Update",
        accessor: "updateTime",
        disableGlobalFilter: true,
        Cell: ({ row }) => {
          return formatDatetime(row.original.updateTime);
        },
      },
    ],
    []
  );

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <>
      <TextField
        id="search-field"
        label="Search News"
        variant="outlined"
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
        }}
      />
      <Button
        type="submit"
        variant="outlined"
        color="primary"
        onClick={() => {
          onChange(value);
        }}
      >
        Search
      </Button>
    </>
  );
}

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Job Opportunities > Position
        </Typography>
      </Box>
      <FilterDiv style={{ marginTop: "20px" }}>
          <p
            className={filterStatus === "all" ? "active": ""}
            onClick={() => filterDataWithStatus("all")}
          >
            All <span>({filterEnabled.length+filterDisabled.length})</span>
          </p>
          |
          <p
            className={filterStatus === "Enable" ? "active": ""}
            onClick={() => filterDataWithStatus("Enable")}
          >
            Enable <span>({filterEnabled.length})</span>
          </p>
          |
          <p
            className={filterStatus === "Disable" ? "active": ""}
            onClick={() => filterDataWithStatus("Disable")}
          >
            {" "}
            Disable <span>({filterDisabled.length})</span>
          </p>
        </FilterDiv>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <DragAndDropTable
            globalFilter={globalFilter}
            orderingDisabled={orderingDisabled}
            handleSorting={handleSorting}
            handleSearch={handleSearch}
            searchString={searchString}
            setSearchString={setSearchString}
            fetchData={getJobs}
            data={rows}
            setData={setRows}
            columns={columns}
            bulkDeleteApi={(ids) => Promise.all(ids.map((id) => apiHelper.hkiff.deleteJobById(id)))}
            subject="event"
            saveOrderingApi={saveOrdering}
            disabled={disabled}
            editDeleteAction={true}
            handleDelete={handleDelete}
            withPagination={true}
            setParentPageSize={setPageSize}
            setParentPageIndex={setPageIndex}
            parentPageIndex={pageIndex}
            totalElements={totalElements}
            totalPages={totalPages}
            addBtnLink={`${props.match.url}/new`}
            addBtnName="Add New Position"
          />
        </Grid>
      </Grid>
    </>
  );
}
